import type { ReactNode } from "react";

interface SectionHeaderProps {
	title: ReactNode;
	subtitle?: ReactNode;
	trailing?: ReactNode;
}

/** Section header with title + subtitle on the left and optional controls on the right. */
export function SectionHeader({
	title,
	subtitle,
	trailing,
}: SectionHeaderProps) {
	return (
		<header className="flex flex-wrap items-end justify-between gap-3">
			<div>
				<h2 className="text-lg font-semibold text-slate-100">{title}</h2>
				{subtitle && <p className="text-xs text-slate-400">{subtitle}</p>}
			</div>
			{trailing}
		</header>
	);
}
